export * from "./generateLicense";
